export * from "./generateLicense";
